import React from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { useNavigate } from "react-router-dom";
// import { DeleteLead } from "../services/leadService";
import { DeleteTeamMember } from "../../services/teamService";
import { useToast } from "../../hooks/useToast";

export function DeleteTeamMemberModal({ memberId, open, setOpen }) {
  const navigate = useNavigate();
    const { toast } = useToast();


  const handleDelete = async () => {
    try {
      const res = await DeleteTeamMember(memberId);
      if (res?.success) {
        setOpen(false);
        navigate("/leads");
      } else {
         toast({
          variant: "destructive",
          title: "Failed to delete lead",
        });
      }
    } catch (err) {
       toast({
          variant: "destructive",
          title: "Delete error:",
        });
    }
  };

  return (
    <AlertDialog.Root open={open} onOpenChange={setOpen}>
      <AlertDialog.Portal>
        {/* Overlay */}
        <AlertDialog.Overlay className="fixed inset-0 bg-black/40 z-40" />

        {/* Content */}
        <AlertDialog.Content className="fixed z-50 left-1/2 top-1/2 w-[90%] max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-lg focus:outline-none">
          <div className="mb-4">
            <AlertDialog.Title className="text-lg font-semibold">
              Warning: This action is irreversible
            </AlertDialog.Title>
            <AlertDialog.Description className="mt-2 text-sm text-gray-600">
              Deleting this team member will permanently remove their access and data. 
              Please make sure you really want to proceed.
            </AlertDialog.Description>
          </div>

          <div className="flex justify-end gap-3">
            <AlertDialog.Cancel asChild>
              <button
                type="button"
                className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
            </AlertDialog.Cancel>

            <AlertDialog.Action asChild>
              <button
                type="button"
                className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-600/90"
                onClick={handleDelete}
              >
                Confirm
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
